import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes, faPlus, faSearch, faUser, faSeedling, faClipboardList,
  faFlask, faEye, faCalendarCheck, faCamera, faSpinner, faCheck,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import ModalAlert from "../reusable/ModalAlert";
import getProducts from "../IssueDetails/getProducts";
import getCrops from "../IssueDetails/getAllCrops";
import postAddIssue from "../AddIssue/postAddIssue";
import uploadIssuePhoto from "./uploadIssuePhoto";
import addReminderApi from "../Reminders/addReminder";

const C = {
  dark: "#1a3328", mid: "#2d5a3d", bright: "#3d8c5e",
  light: "#e8f5ee", border: "#d8e8dc",
  white: "#ffffff", textDk: "#1a2e22", textGr: "#6c757d",
  red: "#c62828", redBg: "#fdecea",
};

const inp = {
  width: "100%", height: 38, borderRadius: 8,
  border: `1.5px solid ${C.border}`, padding: "0 12px",
  fontSize: "0.86rem", outline: "none", color: C.textDk,
  boxSizing: "border-box", backgroundColor: C.white,
};
const ta = {
  ...inp, height: "auto", padding: "9px 12px",
  resize: "vertical", lineHeight: 1.5,
};
const lbl = {
  fontSize: "0.78rem", fontWeight: 600, color: C.textDk,
  marginBottom: 4, display: "block",
};
const selectSt = { menuPortal: (b) => ({ ...b, zIndex: 1300 }) };

const CROP_STAGES = ["Seedling", "Vegetative", "Tillering", "Flowering", "Fruiting", "Maturity", "Harvesting"];
const SEASONS     = ["Kharif", "Rabi", "Zaid", "All Season"];
const APP_METHODS = ["Spraying", "Drip Irrigation", "Soil Application", "Seed Treatment", "Foliar Spray", "Fertigation"];

const SectionHeader = ({ icon, title }) => (
  <div style={{
    display: "flex", alignItems: "center", gap: 9,
    marginBottom: "1rem", marginTop: "0.25rem",
    paddingBottom: "0.6rem", borderBottom: `1px solid ${C.border}`,
  }}>
    <div style={{
      width: 28, height: 28, borderRadius: 7, backgroundColor: C.dark,
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <FontAwesomeIcon icon={icon} style={{ color: "#fff", fontSize: "0.78rem" }} />
    </div>
    <span style={{ fontWeight: 700, fontSize: "0.92rem", color: C.dark }}>{title}</span>
  </div>
);

const PhotoBox = ({ label, url, onUpload, uploading }) => {
  const ref = useRef(null);
  return (
    <div>
      <label style={lbl}>{label}</label>
      <div
        onClick={() => !uploading && ref.current?.click()}
        style={{
          border: `1.5px dashed ${C.border}`, borderRadius: 10,
          minHeight: 100, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center", cursor: "pointer",
          backgroundColor: "#fafcfb", gap: 6, overflow: "hidden",
        }}
      >
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} spin style={{ color: C.mid, fontSize: "1.4rem" }} />
        ) : url ? (
          <img src={url} alt="preview" style={{ width: "100%", maxHeight: 140, objectFit: "cover", borderRadius: 9 }} />
        ) : (
          <>
            <span style={{ fontSize: "1.6rem", color: "#c0cfc5" }}>🖼</span>
            <span style={{ fontSize: "0.75rem", color: C.textGr }}>Click to upload / Attach photo</span>
          </>
        )}
      </div>
      <input ref={ref} type="file" accept="image/*" style={{ display: "none" }} onChange={onUpload} />
    </div>
  );
};

const AddIssueDrawer = ({ onClose, onSuccess, preSelectedCropID, farmer: farmerProp }) => {

  const [allProducts, setAllProducts] = useState([]);
  const [allCrops,    setAllCrops]    = useState([]);

  // ── Farmer search (hidden when farmerProp is supplied) ────────────────────
  const [farmerSearch,   setFarmerSearch]   = useState("");
  const [farmerResults,  setFarmerResults]  = useState([]);
  const [farmer,         setFarmer]         = useState(farmerProp || null);
  const [farmerError,    setFarmerError]    = useState("");
  const [lookingUp,      setLookingUp]      = useState(false);

  // ── Section 1 — Crop Basic Details ────────────────────────────────────────
  const [cropID,        setCropID]        = useState(preSelectedCropID ? String(preSelectedCropID) : "");
  const [cropStage,     setCropStage]     = useState("");
  const [season,        setSeason]        = useState("");
  const [variety,       setVariety]       = useState("");
  const [sowingDate,    setSowingDate]    = useState("");
  const [areaUnderCrop, setAreaUnderCrop] = useState("");

  // ── Section 2 — Problem Description ───────────────────────────────────────
  const [lastDoseTaken, setLastDoseTaken] = useState("");
  const [symptomsText,  setSymptomsText]  = useState("");
  const [issueType,     setIssueType]     = useState("Crop Related");
  const [categoryID,    setCategoryID]    = useState("");
  const [title,         setTitle]         = useState("");
  const [description,   setDescription]   = useState("");

  // ── Section 3 — Recommendation Details ────────────────────────────────────
  const [selectedProds,     setSelectedProds]     = useState([]);
  const [applicationMethod, setApplicationMethod] = useState("");
  const [dosage,            setDosage]            = useState("");

  // ── Section 5 — Field Observation ─────────────────────────────────────────
  const [fieldObservation,  setFieldObservation]  = useState("");
  const [issueVerification, setIssueVerification] = useState("");

  // ── Section 6 — Follow-Up ─────────────────────────────────────────────────
  const [nextFollowUpDate, setNextFollowUpDate] = useState("");
  const [marketstaff,      setMarketstaff]      = useState("");

  // ── Section 7 — Photos ────────────────────────────────────────────────────
  const [beforePhoto,     setBeforePhoto]     = useState("");
  const [afterPhoto,      setAfterPhoto]      = useState("");
  const [uploadingBefore, setUploadingBefore] = useState(false);
  const [uploadingAfter,  setUploadingAfter]  = useState(false);

  const [saving, setSaving] = useState(false);
  const [alert,  setAlert]  = useState(null);

  // auto-set assignee from localStorage — no UI needed
  const loggedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const assignee   = loggedUser._id || loggedUser.id || "";

  useEffect(() => {
    Promise.all([getProducts(), getCrops()]).then(([p, c]) => {
      if (p.status === 200) setAllProducts(p.data);
      if (c.status === 200) setAllCrops(c.data);
    });
  }, []);

  // ── Farmer search ──────────────────────────────────────────────────────────
  const doSearch = () => {
    if (!farmerSearch.trim()) { setFarmerError("Enter a name or mobile number."); return; }
    setLookingUp(true); setFarmerError(""); setFarmerResults([]); setFarmer(null);
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/farmer/searchFarmer`, { search: farmerSearch.trim() })
      .then((res) => {
        const arr = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        if (arr.length === 0) {
          setFarmerError("No farmer found.");
        } else if (arr.length === 1) {
          setFarmer(arr[0]);
        } else {
          setFarmerResults(arr);
        }
      })
      .catch(() => setFarmerError("Search failed. Please try again."))
      .finally(() => setLookingUp(false));
  };

  const selectFarmer = (f) => {
    setFarmer(f);
    setFarmerResults([]);
    setFarmerSearch("");
  };

  // ── Photo upload ───────────────────────────────────────────────────────────
  const handlePhotoUpload = async (file, side) => {
    if (side === "before") setUploadingBefore(true);
    else setUploadingAfter(true);
    const res = await uploadIssuePhoto(file);
    if (res?.data?.imageUrl) {
      side === "before" ? setBeforePhoto(res.data.imageUrl) : setAfterPhoto(res.data.imageUrl);
    }
    if (side === "before") setUploadingBefore(false);
    else setUploadingAfter(false);
  };

  // Fix: use loose == so string select value matches numeric _id
  const selectedCropObj = allCrops.find(c => String(c._id) === String(cropID));
  const categories = selectedCropObj?.categories || [];

  // ── Submit ─────────────────────────────────────────────────────────────────
  const handleSubmit = async () => {
    if (!farmer)   { setAlert({ variant: "danger", message: "Please select a farmer first." }); return; }
    if (!assignee) { setAlert({ variant: "danger", message: "Logged-in user not found. Please re-login." }); return; }

    const payload = {
      farmerID:            farmer._id,
      reporter:            assignee,
      assignee,
      issueType,
      status:              "New",
      title,
      description,
      cropID:              (issueType === "Other" || issueType === "Soil Related") ? null : cropID || null,
      categoryID:          (issueType === "Other" || issueType === "Soil Related") ? null : categoryID || null,
      productsRecommended: selectedProds,
      labels:              [],
      cropStage,
      season,
      variety,
      sowingDate:          sowingDate || null,
      areaUnderCrop,
      lastDoseTaken,
      symptomsText,
      applicationMethod,
      dosage,
      fieldObservation,
      issueVerification:   issueVerification || null,
      nextFollowUpDate:    nextFollowUpDate || null,
      marketstaff,
      beforePhoto,
      afterPhoto,
    };

    setSaving(true);
    const res = await postAddIssue(payload);
    if (res?.status === 200) {
      const issueCode = res.data?.issue?.issueCode;
      addReminderApi({
        title:           title ? `Query: ${title}` : `New Query: ${issueCode}`,
        farmerName:      farmer.fullName || "",
        farmerMobile:    farmer.mobileNumber || "",
        reminderDate:    nextFollowUpDate || null,
        reminderTime:    null,
        urgency:         "moderatepriority",
        source:          "query",
        issueCode,
        createdByUserId: String(loggedUser._id || loggedUser.id || ""),
        createdByName:   loggedUser.fullName || "",
      });
      onSuccess(issueCode);
    } else {
      setAlert({ variant: "danger", message: "Failed to add query. Please try again." });
      setSaving(false);
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.45)", zIndex: 1100 }} />

      {/* Panel — 20% wider: 760 × 1.2 = 912 */}
      <div style={{
        position: "fixed", top: 0, right: 0, bottom: 0,
        width: "min(912px, 97vw)",
        backgroundColor: C.white,
        boxShadow: "-4px 0 24px rgba(0,0,0,0.18)",
        zIndex: 1200,
        display: "flex", flexDirection: "column",
        animation: "drawerIn 0.25s ease",
      }}>
        <style>{`@keyframes drawerIn { from { transform: translateX(100%); } to { transform: translateX(0); } }`}</style>

        {/* Header */}
        <div style={{
          backgroundColor: C.dark, padding: "1rem 1.5rem", flexShrink: 0,
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 8, backgroundColor: C.mid, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <FontAwesomeIcon icon={faPlus} style={{ color: "#fff", fontSize: "0.85rem" }} />
            </div>
            <div>
              <div style={{ fontWeight: 700, fontSize: "0.95rem", color: "#fff" }}>Add New Query</div>
              <div style={{ fontSize: "0.7rem", color: "rgba(255,255,255,0.5)" }}>
                Raise a new crop query · {loggedUser.fullName || ""}
              </div>
            </div>
          </div>
          <button onClick={onClose} style={{
            background: "rgba(255,255,255,0.12)", border: "none", cursor: "pointer",
            width: 32, height: 32, borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
          }}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Body */}
        <div style={{ flex: 1, overflowY: "auto", padding: "1.25rem" }}>

          {/* ── Farmer Section ────────────────────────────────────────────── */}
          <div style={{ marginBottom: "1.25rem", padding: "1rem 1.1rem", border: `1.5px solid ${C.border}`, borderRadius: 10, backgroundColor: "#fafcfb" }}>
            <div style={{ fontWeight: 700, fontSize: "0.8rem", color: C.dark, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.05em" }}>
              Farmer
            </div>

            {/* Show search only when no farmer is pre-selected via prop */}
            {!farmerProp && (
              <>
                <div style={{ display: "flex", gap: 8 }}>
                  <input
                    value={farmerSearch}
                    onChange={e => { setFarmerSearch(e.target.value); setFarmerError(""); }}
                    onKeyDown={e => e.key === "Enter" && doSearch()}
                    placeholder="Search by name or mobile number…"
                    style={{ ...inp, flex: 1 }}
                  />
                  <button onClick={doSearch} disabled={lookingUp} style={{
                    height: 38, padding: "0 14px", borderRadius: 8, border: "none",
                    cursor: lookingUp ? "not-allowed" : "pointer",
                    fontSize: "0.82rem", fontWeight: 600, backgroundColor: C.mid, color: "#fff",
                    display: "flex", alignItems: "center", gap: 6, flexShrink: 0,
                  }}>
                    {lookingUp
                      ? <FontAwesomeIcon icon={faSpinner} spin />
                      : <FontAwesomeIcon icon={faSearch} style={{ fontSize: "0.68rem" }} />}
                    {lookingUp ? "Searching…" : "Search"}
                  </button>
                </div>

                {farmerError && (
                  <div style={{ fontSize: "0.78rem", color: C.red, marginTop: 6 }}>{farmerError}</div>
                )}

                {/* Multiple results — pick list */}
                {farmerResults.length > 0 && (
                  <div style={{ marginTop: 8, border: `1px solid ${C.border}`, borderRadius: 8, overflow: "hidden", maxHeight: 220, overflowY: "auto" }}>
                    {farmerResults.map((f, i) => (
                      <div
                        key={f._id || i}
                        onClick={() => selectFarmer(f)}
                        style={{
                          display: "flex", alignItems: "center", gap: 10,
                          padding: "0.5rem 0.8rem", cursor: "pointer",
                          borderBottom: i < farmerResults.length - 1 ? `1px solid ${C.border}` : "none",
                          backgroundColor: "#fff",
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = C.light}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = "#fff"}
                      >
                        <div style={{ width: 28, height: 28, borderRadius: 7, backgroundColor: C.mid, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                          <FontAwesomeIcon icon={faUser} style={{ color: "#fff", fontSize: "0.7rem" }} />
                        </div>
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontWeight: 700, fontSize: "0.85rem", color: C.textDk }}>{f.fullName}</div>
                          <div style={{ fontSize: "0.7rem", color: C.textGr }}>{f.mobileNumber}{f.district ? ` · ${f.district}` : ""}{f.state ? `, ${f.state}` : ""}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}

            {/* Farmer chip — always shown once selected; no clear button when pre-selected via prop */}
            {farmer && (
              <div style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                gap: 10, padding: "0.55rem 0.8rem", borderRadius: 9, marginTop: farmerProp ? 0 : 8,
                backgroundColor: C.light, border: `1px solid ${C.border}`,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 30, height: 30, borderRadius: 8, backgroundColor: C.mid, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <FontAwesomeIcon icon={faCheck} style={{ color: "#fff", fontSize: "0.7rem" }} />
                  </div>
                  <div>
                    <div style={{ fontWeight: 700, fontSize: "0.87rem", color: C.textDk }}>{farmer.fullName}</div>
                    <div style={{ fontSize: "0.72rem", color: C.textGr }}>
                      {farmer.mobileNumber}{farmer.district ? ` · ${farmer.district}` : ""}{farmer.state ? `, ${farmer.state}` : ""}
                    </div>
                  </div>
                </div>
                {!farmerProp && (
                  <button
                    onClick={() => { setFarmer(null); setFarmerSearch(""); }}
                    style={{ background: "none", border: "none", color: C.textGr, cursor: "pointer", fontSize: "1rem", lineHeight: 1, padding: "0 4px" }}
                    title="Clear selection"
                  >×</button>
                )}
              </div>
            )}
          </div>

          {/* ── Section 1: Crop Basic Details ─────────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faSeedling} title="Crop Basic Details" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.85rem", marginBottom: "0.85rem" }}>
              <div>
                <label style={lbl}>Crop</label>
                <select value={cropID} onChange={e => { setCropID(e.target.value); setCategoryID(""); }} style={inp}>
                  <option value="">Select Crop</option>
                  {allCrops.map(c => <option key={c._id} value={String(c._id)}>{c.crop}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Crop Stage</label>
                <select value={cropStage} onChange={e => setCropStage(e.target.value)} style={inp}>
                  <option value="">Select Stage</option>
                  {CROP_STAGES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Season</label>
                <select value={season} onChange={e => setSeason(e.target.value)} style={inp}>
                  <option value="">Select Season</option>
                  {SEASONS.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.85rem" }}>
              <div>
                <label style={lbl}>Variety</label>
                <input value={variety} onChange={e => setVariety(e.target.value)} placeholder="Enter Variety" style={inp} />
              </div>
              <div>
                <label style={lbl}>Sowing Date</label>
                <input type="date" value={sowingDate} onChange={e => setSowingDate(e.target.value)} style={inp} />
              </div>
              <div>
                <label style={lbl}>Area Under Crop (Acre/Hectare)</label>
                <input value={areaUnderCrop} onChange={e => setAreaUnderCrop(e.target.value)} placeholder="Enter Area" style={inp} />
              </div>
            </div>
          </div>

          {/* ── Section 2: Problem Description ────────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faClipboardList} title="Problem Description & History" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem", marginBottom: "0.85rem" }}>
              <div>
                <label style={lbl}>Last Dose Taken</label>
                <textarea value={lastDoseTaken} onChange={e => setLastDoseTaken(e.target.value)} placeholder="Enter last dose taken" rows={3} style={ta} />
              </div>
              <div>
                <label style={lbl}>Symptoms</label>
                <textarea value={symptomsText} onChange={e => setSymptomsText(e.target.value)} placeholder="Enter symptoms" rows={3} style={ta} />
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem", marginBottom: "0.85rem" }}>
              <div>
                <label style={lbl}>Query Type</label>
                <select value={issueType} onChange={e => { setIssueType(e.target.value); setCropID(""); setCategoryID(""); }} style={inp}>
                  <option value="Crop Related">Crop Related</option>
                  <option value="Soil Related">Soil Related</option>
                  <option value="Fertilizer Management">Fertilizer Management</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div>
                <label style={lbl}>Query Category</label>
                <select
                  value={categoryID}
                  onChange={e => setCategoryID(e.target.value)}
                  style={{ ...inp, opacity: (!cropID || issueType === "Other" || issueType === "Soil Related") ? 0.5 : 1 }}
                  disabled={!cropID || issueType === "Other" || issueType === "Soil Related"}
                >
                  <option value="">Select Query Category</option>
                  {categories.map(cat => <option key={cat._id} value={String(cat._id)}>{cat.category}</option>)}
                </select>
              </div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem" }}>
              <div>
                <label style={lbl}>Crop Query (Online)</label>
                <textarea value={title} onChange={e => setTitle(e.target.value)} placeholder="Enter crop query" rows={3} style={ta} />
              </div>
              <div>
                <label style={lbl}>Query Description</label>
                <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Enter query description" rows={3} style={ta} />
              </div>
            </div>
          </div>

          {/* ── Section 3: Recommendation Details ────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faFlask} title="Recommendation Details" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0.85rem" }}>
              <div>
                <label style={lbl}>Recommended Product</label>
                <Select
                  isMulti
                  options={allProducts}
                  value={selectedProds}
                  onChange={setSelectedProds}
                  getOptionLabel={o => o.product}
                  getOptionValue={o => o._id}
                  placeholder="Select products…"
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={selectSt}
                />
              </div>
              <div>
                <label style={lbl}>Application Method</label>
                <select value={applicationMethod} onChange={e => setApplicationMethod(e.target.value)} style={inp}>
                  <option value="">Select Application Method</option>
                  {APP_METHODS.map(m => <option key={m} value={m}>{m}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Dosage</label>
                <input value={dosage} onChange={e => setDosage(e.target.value)} placeholder="Enter dosage" style={inp} />
              </div>
            </div>
          </div>

          {/* ── Section 5: Field Observation ──────────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faEye} title="Field Observation" />
            <div style={{ marginBottom: "0.85rem" }}>
              <label style={lbl}>Crop Query (On Field)</label>
              <textarea value={fieldObservation} onChange={e => setFieldObservation(e.target.value)} placeholder="Enter crop query observed in field" rows={3} style={{ ...ta, width: "100%" }} />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
              <span style={{ ...lbl, marginBottom: 0 }}>Issue Verification</span>
              {["matched", "unmatched"].map(v => (
                <label key={v} style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", fontSize: "0.86rem", color: C.textDk, fontWeight: 500 }}>
                  <input type="radio" name="issueVerif" value={v} checked={issueVerification === v} onChange={() => setIssueVerification(v)} />
                  {v.charAt(0).toUpperCase() + v.slice(1)}
                </label>
              ))}
            </div>
          </div>

          {/* ── Section 6: Follow-Up ──────────────────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faCalendarCheck} title="Follow-Up" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem" }}>
              <div>
                <label style={lbl}>Next Follow-Up Date</label>
                <input type="date" value={nextFollowUpDate} onChange={e => setNextFollowUpDate(e.target.value)} style={inp} />
              </div>
              <div>
                <label style={lbl}>Referred to Marketing Staff</label>
                <input value={marketstaff} onChange={e => setMarketstaff(e.target.value)} placeholder="Enter name or details" style={inp} />
              </div>
            </div>
          </div>

          {/* ── Section 7: Photo Documentation ────────────────────────────── */}
          <div style={{ border: `1.5px solid ${C.border}`, borderRadius: 12, padding: "1rem 1.25rem", marginBottom: "1.1rem" }}>
            <SectionHeader icon={faCamera} title="Photo Documentation" />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
              <PhotoBox
                label="Before Photo"
                url={beforePhoto}
                uploading={uploadingBefore}
                onUpload={e => e.target.files[0] && handlePhotoUpload(e.target.files[0], "before")}
              />
              <PhotoBox
                label="After Photo"
                url={afterPhoto}
                uploading={uploadingAfter}
                onUpload={e => e.target.files[0] && handlePhotoUpload(e.target.files[0], "after")}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: "0.9rem 1.5rem", borderTop: `1px solid ${C.border}`,
          display: "flex", justifyContent: "flex-end", gap: 10,
          backgroundColor: "#fafcfb", flexShrink: 0,
        }}>
          <button onClick={onClose} style={{
            height: 38, padding: "0 18px", borderRadius: 9,
            border: `1.5px solid ${C.border}`, cursor: "pointer",
            fontSize: "0.87rem", fontWeight: 600, color: C.textGr, backgroundColor: C.white,
          }}>
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={saving} style={{
            height: 38, padding: "0 22px", borderRadius: 9, border: "none",
            cursor: saving ? "not-allowed" : "pointer",
            fontSize: "0.87rem", fontWeight: 600,
            backgroundColor: saving ? "#a0b8ab" : C.mid, color: "#fff",
            display: "flex", alignItems: "center", gap: 6,
          }}>
            {saving && <FontAwesomeIcon icon={faSpinner} spin />}
            {saving ? "Saving…" : "Add Query"}
          </button>
        </div>
      </div>

      {alert && (
        <ModalAlert variant={alert.variant} message={alert.message} resetCallback={() => setAlert(null)} />
      )}
    </>
  );
};

export default AddIssueDrawer;
